import React from 'react';
import { useNavigate } from 'react-router-dom';
import PageLayout from '../components/layout/PageLayout';
import { getRankFromScore, RANK_THRESHOLDS } from '../utils/rankSystem';
import styles from './RanksPage.module.css';

const RanksPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <PageLayout>
      <div className={styles.container}>
        <h1 className={styles.title}>Rank System</h1>
        <p className={styles.subtitle}>
          Achieve higher ranked scores to unlock prestigious ranks. Each rank represents
          your skill and dedication to identifying artists.
        </p>

        <div className={styles.ranksGrid}>
          {[...RANK_THRESHOLDS].reverse().map((rank) => {
            const rankInfo = getRankFromScore(rank.score);
            const isTheLost = rank.name === 'The Lost';
            return (
              <div
                key={rank.score}
                className={`${styles.rankCard} ${isTheLost ? styles.rankCardWide : ''}`}
                style={{
                  background: rankInfo.background,
                  borderColor: rankInfo.borderColor,
                  boxShadow: `0 4px 12px ${rankInfo.shadowColor}`,
                }}
              >
                <div className={styles.rankHeader}>
                  <div
                    className={styles.rankName}
                    style={{
                      color: rankInfo.textColor,
                      textShadow:
                        rankInfo.textColor === '#fff'
                          ? '2px 2px 4px rgba(0, 0, 0, 0.3)'
                          : 'none',
                    }}
                  >
                    {rank.name}
                  </div>
                  <div
                    className={styles.rankThreshold}
                    style={{
                      color: rankInfo.textColor,
                      opacity: 0.9,
                    }}
                  >
                    {rank.score}+ Points
                  </div>
                </div>
                <div
                  className={styles.rankDescription}
                  style={{
                    color: rankInfo.textColor,
                    opacity: 0.85,
                  }}
                >
                  {rank.description}
                </div>
              </div>
            );
          })}
        </div>

        <div className={styles.infoSection}>
          <h2>How to Increase Your Score</h2>
          <ul>
            <li>
              <strong>Difficulty Multipliers:</strong> Enable add-ons like blur, cropping,
              and time limits to increase your score multiplier
            </li>
            <li>
              <strong>Artist Pool:</strong> A larger artist pool increases your score
              multiplier (e.g., 200 artists = 2x multiplier)
            </li>
            <li>
              <strong>Get Answers Right:</strong> Each correct answer in ranked mode
              contributes to your final score
            </li>
          </ul>
        </div>

        <button className={styles.backButton} onClick={() => navigate('/')}>
          Back to Home
        </button>
      </div>
    </PageLayout>
  );
};

export default RanksPage;

